/**
 * schemas/config/gates.ts
 * ──────────────────────────────────────────────────────────────────────────
 * The gate map, in its own module.
 *
 * It lives here rather than in bootstrap.ts because almost every response
 * carries it — bootstrap, policy, reconciliation, sync and settlement all
 * embed the same object. With it declared in bootstrap.ts, policy.ts had to
 * import bootstrap and bootstrap had to import policy, and the resulting cycle
 * left `policyResponseSchema` undefined at import time: a runtime
 * "Cannot read properties of undefined (reading '_parse')" the typechecker
 * cannot see. A leaf module with no imports of its own cannot be part of a
 * cycle.
 *
 * Keys are the API's own, from
 * sk-company-cash-api/src/services/policy/gates.ts. `true` means SATISFIED.
 * ──────────────────────────────────────────────────────────────────────────
 */
import { z } from 'zod';

export const gateStateSchema = z.object({
  /** Base currency + approval threshold. False means show onboarding. */
  console: z.boolean(),
  categories: z.boolean(),
  variance_set: z.boolean(),
  /** BOTH payroll and billing — either alone leaves half the queue stuck. */
  connectors: z.boolean(),
  offboard_feed: z.boolean(),
});
export type GateStateResponse = z.infer<typeof gateStateSchema>;
